export default {
  path: '/siteadmin/naturalretreats/logs',
  async action(...args) {
    return (await import('./loader')).default(...args);
  },
};
